<template>
    <div class="catalog-filter-sidebar">
        <div class="row d-lg-none m-0 p-0 d-flex justify-content-end">
            <button class="filter-toggle mb-3 btn btn-secondary" @click="showFilterForce = !showFilterForce">
                Filter
            </button>
        </div>

        <b-collapse :visible="showFilter" class="mb-3">
            <section id="filter-sidebar-header">
                <filter-sidebar-header class="mb-5"></filter-sidebar-header>
            </section>

            <section id="subscription-price-box" v-show="filterExists('price')">
                <filter-subscription-price-box class="mb-5"></filter-subscription-price-box>
            </section>

            <section id="free-mileage-box" v-show="filterExists('mileage')">
                <filter-free-mileage-box class="mb-5"></filter-free-mileage-box>
            </section>

            <section id="duration-option-box" v-show="filterExists('minimum_duration')">
                <filter-duration-option-box class="mb-5"></filter-duration-option-box>
            </section>

            <section id="duration-box" v-show="filterExists('minimum_duration')">
                <filter-duration-box class="mb-5"></filter-duration-box>
            </section>

            <div class="list-group">
                <filter-brand-model-box id="brand-model-box" v-show="filterExists('brand')"></filter-brand-model-box>

                <filter-vehicle-condition-box id="vehicle_condition-model-box" v-show="filterExists('vehicle_condition')"></filter-vehicle-condition-box>

                <filter-gearshift-box id="gearshift-box" v-show="filterExists('gearshift')"></filter-gearshift-box>

                <filter-fuel-box id="fuel-box" v-show="filterExists('fuel')"></filter-fuel-box>

                <filter-power-box id="power-box" v-show="filterExists('power')"></filter-power-box>

                <filter-vehicle-type-box id="vehicle-type-box" v-show="filterExists('category')"></filter-vehicle-type-box>

                <filter-feature-box id="feature-box" v-show="filterExists('top_feature')"></filter-feature-box>
            </div>
        </b-collapse>

        <ad name="ad_below_filter" class="mt-3 d-none d-lg-inline"></ad>
    </div>
</template>

<script>
import Ad from "../atoms/Ad.vue";
import FilterSubscriptionPriceBox from "../molecules/FilterSubscriptionPriceBox.vue";
import FilterFreeMileageBox from "../molecules/FilterFreeMileageBox.vue";
import FilterVehicleConditionBox from "../molecules/FilterVehicleConditionBox.vue";
import FilterDurationBox from "../molecules/FilterDurationBox.vue";
import FilterDurationOptionBox from "../molecules/FilterDurationOptionBox.vue";
import FilterSidebarHeader from "../molecules/FilterSidebarHeader.vue";
import FilterBrandModelBox from "../molecules/FilterBrandModelBox.vue";
import FilterGearshiftBox from "../molecules/FilterGearshiftBox.vue";
import FilterFuelBox from "../molecules/FilterFuelBox.vue";
import FilterPowerBox from "../molecules/FilterPowerBox.vue";
import FilterVehicleTypeBox from "../molecules/FilterVehicleTypeBox.vue";
import FilterFeatureBox from "../molecules/FilterFeatureBox.vue";
import { BCollapse } from "bootstrap-vue";
import { EventBus } from "../../event-bus"

export default {
    name: 'CatalogFilterSidebar',
    components: {
        Ad,
        BCollapse,
        FilterFeatureBox,
        FilterVehicleTypeBox,
        FilterPowerBox,
        FilterFuelBox,
        FilterGearshiftBox,
        FilterBrandModelBox,
        FilterSidebarHeader,
        FilterDurationBox,
        FilterDurationOptionBox,
        FilterFreeMileageBox,
        FilterVehicleConditionBox,
        FilterSubscriptionPriceBox,
    },
    data(){
      return {
          filters: undefined,
          isLoading: true,
          showFilterForce: false,
      }
    },
    methods: {
        getFilterTemplates(){
            fetch('/api/v1/catalog/filter_template')
                .then(response => response.json())
                .then(data => {
                    this.filters = data
                    EventBus.$emit('catalog-filters-received', data);
                });
        },

        filterExists(name) {
            if(this.filters){
                const whitelabel_settings = this.$root.whitelabel.getSettings();
                const whitelabel_filter = whitelabel_settings.filters;
                const entry = this.filters.find(f => f.name === name)
                return (entry.values.length > 0 && whitelabel_filter.includes(name))
            }
            return false
        },
    },
    created() {
        this.getFilterTemplates();
    },
    computed: {
        showFilter() {
            return this.$root.breakpoints.gt.lg || this.showFilterForce;
        },
    }
}
</script>
